// extracted by mini-css-extract-plugin
export default {"community__row":"community_community__row__eTYrH","communitycard":"community_communitycard__GfFy4","communitycard__wrapper":"community_communitycard__wrapper__kscR5"};